import React from 'react'


const AboutMe = () => {
    return (
        <div className="about-me">
            <h4>
                Hello I am Matthew Casey (everyone calls me Matt) and I am an aspiring Software Devloper looking to progress my skills. If you like
                    what you see here please reach out via linkedin or send me an email through my contact page. Thank you for your
                    time in viewing my Portfolio. Enjoy!
            </h4>
        </div>
    )
}

export default AboutMe

